import { render, staticRenderFns } from "./centurion-dining.vue?vue&type=template&id=146ad604&scoped=true&"
import script from "./centurion-dining.vue?vue&type=script&lang=js&"
export * from "./centurion-dining.vue?vue&type=script&lang=js&"
import style0 from "./centurion-dining.vue?vue&type=style&index=0&id=146ad604&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146ad604",
  null
  
)

export default component.exports